import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as i}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as C}from"../../icon-registry.js";const e=C("ria",i`
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            static
            xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_5844_370)">
                <mask
                    id="mask0_5844_370"
                    style="mask-type:alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="24"
                    height="24">
                    <circle
                        cx="12"
                        cy="12"
                        r="12"
                        fill="#FCFCFC" />
                </mask>
                <g mask="url(#mask0_5844_370)">
                    <path
                        d="M24 0H0V24H24V0Z"
                        fill="#FF6100" />
                    <path
                        d="M5.13445 10.9963C6.01914 10.2031 7.23011 9.94546 8.37405 9.92188C8.37527 10.6667 8.37405 11.4116 8.37466 12.1564C7.74502 12.1862 7.05307 12.3184 6.61073 12.8211C6.24155 13.2326 6.15935 13.8211 6.1793 14.3598C6.18108 15.1804 6.17992 16.0009 6.17992 16.8215C5.45353 16.8215 4.72721 16.8209 4.00144 16.8221C4.00322 15.7508 3.99481 14.6795 4.00567 13.6082C4.02562 12.6312 4.4021 11.64 5.13445 10.9963Z"
                        fill="white" />
                    <path
                        d="M9.81055 9.92188C10.5357 9.92188 11.2609 9.92188 11.986 9.92188C11.9866 12.2216 11.9866 14.5206 11.986 16.8196C11.2609 16.8196 10.5357 16.8196 9.81055 16.8196C9.81055 14.5206 9.81055 12.2216 9.81055 9.92188Z"
                        fill="white" />
                    <path
                        d="M10.5412 6.04992C11.3376 5.81713 12.2307 6.42792 12.3293 7.2714C12.4707 8.07211 11.8567 8.8995 11.0687 8.97271C10.3182 9.08633 9.55922 8.49168 9.46314 7.72078C9.33626 6.98652 9.83417 6.21625 10.5412 6.04992Z"
                        fill="white" />
                    <path
                        d="M14.3798 10.555C15.1152 9.96969 16.0826 9.75058 16.9993 9.8456C17.7789 9.91572 18.5506 10.2447 19.0944 10.8331C19.5639 11.3334 19.848 11.9981 19.9477 12.6809C20.0105 13.0713 19.9996 13.4673 19.9996 13.8614C19.9996 14.8483 20.0003 15.8353 19.9996 16.8227C19.2696 16.8221 18.5391 16.8234 17.8091 16.8221C17.8055 16.4807 17.82 16.1394 17.797 15.7993C17.3057 16.1667 16.8253 16.549 16.3389 16.9227C15.453 16.8358 14.5514 16.5043 13.9381 15.8179C13.2274 15.0389 13.0008 13.9061 13.1217 12.8696C13.2231 11.9683 13.6721 11.105 14.3798 10.555ZM16.293 12.0366C16.0289 12.0881 15.7799 12.2253 15.6005 12.432C15.1382 12.9639 15.1569 13.8701 15.6548 14.3717C16.0518 14.7739 16.7135 14.8459 17.1951 14.5659C17.9505 14.1308 18.0315 12.9118 17.3982 12.3308C17.1045 12.0546 16.6785 11.9609 16.293 12.0366Z"
                        fill="white" />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_5844_370">
                    <rect
                        width="24"
                        height="24"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{e as Ria};
